import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';
import { UPDATE_APP_SUBSCRIPTION_RESOURCE } from '../../constants';

const UpdateAppSubscriptionService = ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_APP_SUBSCRIPTION_RESOURCE,
      method: 'put',
      request: (body, callback, t) => ({
        url: apiRoutes.organisationApps(),
        body,
        meta: {
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateAppSubscriptionFailed'),
            onSuccessMessage: t('updateAppSubscriptionSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UpdateAppSubscriptionService;
